<div
    class="gap-[40px] flex flex-col vh-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] relative ">
    <!-- Loader -->
    <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
        <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
        <span class="text-[#111215ff] font-['archivo'] text-[18px]">{{ loadingLabel }}</span>
    </div>
    <!-- Content -->
    <ng-container *ngIf="!isLoading">
        <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center"
             [@pageTransition]="pageTransitionState">
    <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch"> <span
            class="shrink-0 justify-start items-start text-[#111215ff] text-center font-normal font-['archivo'] text-[24px] leading-[26px]">
            {{ welcomeBefore }}<strong>{{ staffInfoData?.staffName }}</strong>{{ welcomeAfter }} </span> <span
            class="w-[700px] shrink-0 justify-start items-start text-[#444955ff] text-center font-normal font-['archivo'] text-[20px] leading-[28px]">
            {{ subtitle }} </span>
    </div>
<div class="gap-[28px] flex flex-row flex-wrap w-[100%] shrink-0 justify-center items-center self-stretch pb-[8px]" >
    <a *ngFor="let card of cards; index as i; trackBy: trackByCardId"
        [ngClass]="card.cardClass"
        [@cardClick]="clickedCard === card.id ? 'clicked' : ''"
        href="javascript:void(0)"
        (click)="onCardClick(card.route, card.id, $event, card.queryParams)"
        [attr.aria-label]="cardAriaLabel(card)">
        <div class="relative w-full h-[314px] overflow-hidden rounded-t-[8px] bg-slate-100">
            <!-- Image Skeleton Loader -->
            <div *ngIf="!imagesLoaded[card.id]"
                 class="absolute inset-0 w-full h-full image-skeleton pointer-events-none"></div>
            <!-- Actual Image -->
            <img *ngIf="card.image"
                class="w-full h-full object-cover transition-opacity duration-300 pointer-events-none"
                [src]="getImageUrl(card.image)"
                [alt]="cardTitle(card)"
                [attr.width]="card.width"
                [attr.height]="card.height"
                [attr.loading]="i === 0 ? 'eager' : 'lazy'"
                [attr.fetchpriority]="i === 0 ? 'high' : 'low'"
                [attr.decoding]="i === 0 ? 'sync' : 'async'"
                [ngClass]="card.imgClass"
                [class.opacity-0]="!imagesLoaded[card.id]"
                [class.opacity-100]="imagesLoaded[card.id]"
                (load)="onImageLoad(card.id)"
                (error)="onImageError(card.id)" />
        </div>
        <div
            class="gap-[16px] flex flex-col w-[100%] rounded-br-[16px] rounded-bl-[16px] shrink-0 justify-start items-center self-stretch pl-[16px] pr-[16px] pt-[16px] pb-[16px]">
            <div class="gap-[8px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch"> <span
                    class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-bold font-['archivo'] text-[20px] capitalize leading-[22px]">
                    {{ cardTitle(card) }} </span> <span
                    class="w-[100%] h-[48px] shrink-0 justify-start items-start self-stretch text-[#444955ff] text-center font-normal font-['archivo'] text-[16px] leading-[24px] text-wrap inline-block max-w-[314px]">
                    {{ cardDescription(card) }} </span> </div>
        </div>
    </a>
</div>
        </div>
    </ng-container>
</div>
